// src/components/PreviewPageData.jsx
import React, { useState, useEffect } from "react";
import { Loader, Copy, ExternalLink, X } from "lucide-react";
import { renderPreviewComponent } from "./utils/renderPreviewComponent";
import EnlargedImageModal from "./components/ui/EnlargedImageModal"; // 👈 引入独立的放大组件
import { API_BASE } from "./api/config";

// 检查是否为预览模式
export const PreviewPageData = ({ previewData }) => {
  const [enlargedImage, setEnlargedImage] = useState(null);

  if (previewData) {
    try {
      const decodedData = JSON.parse(decodeURIComponent(atob(previewData)));
      return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
          <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8">
            <div className="space-y-6">
              {decodedData.map((component, index) => (
                <div key={index} className="text-center">
                  {renderPreviewComponent(component)}
                </div>
              ))}
            </div>
          </div>

          {/* 图片放大查看模态框 */}
          <EnlargedImageModal
            src={enlargedImage}
            onClose={() => setEnlargedImage(null)}
          />
        </div>
      );
    } catch (error) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <div className="text-2xl font-bold text-red-600 mb-4">
              无效的页面数据
            </div>
            <button
              onClick={() =>
                window.history.replaceState({}, "", window.location.pathname)
              }
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
            >
              返回编辑器
            </button>
          </div>
        </div>
      );
    }
  }
};
